import React from 'react';
import {
    SendCompanyMachineMissingInfoEmailTask
} from "./sendMissingInfoEmail/ws/SendCompanyMachineMissingInfoEmailTask";
import {
    SendCompanyMachineMissingInfoEmailRequest
} from "./sendMissingInfoEmail/ws/SendCompanyMachineMissingInfoEmailRequest";
import ConfirmModal from "../../../shared/components/confirm-modal/ConfirmModal";
import HeaderSearchRefreshFilterOptions from "../../../shared/components/HeaderSearchRefreshFilterOptions";
import Alert from "react-s-alert";
import {Field, reduxForm} from 'redux-form';
import PropTypes from 'prop-types';
import {MachineFormValidator} from './MachineFormValidator';
import Card from '../../../shared/components/Card';
import CardHeader from '../../../shared/components/card-header/CardHeader';
import CardBody from '../../../shared/components/CardBody';
import {I18nUtils} from '../../../../i18n/I18nUtils';
import {FormText} from '../../../shared/components/FormText';
import Row from '../../../shared/components/Row';
import {FormSwitch} from '../../../shared/components/FormSwitch';
import {FormSubmit} from '../../../shared/components/FormSubmit';
import {ResourceOutsource} from '../../../shared/components/predefined-fields/resource-outsource/ResourceOutsource';
import {
    ResourceContractorSchema
} from '../../../shared/components/predefined-fields/resource-contractor-schema/ResourceContractorSchema';
import DocumentSchemaType from '../../../shared/model/DocumentSchemaType';

const OptionsMore = {
    NONE: '',
    ASK_INFORMATION_TO_CONTRACTOR: 'ASK_INFORMATION_TO_CONTRACTOR',
};

const FORM = {
    NAME: 'ContractorMachineForm',
    FIELDS: {
        LICENSE_PLATE: 'licensePlate',
        STATE: 'state',
        BRAND: 'brand',
        MODEL: 'model',
        DESCRIPTION: 'description',
        OUTSOURCE: 'outsource',
        CONTRACTOR_ID: 'contractorId',
        CONTRACTOR_SCHEMA: 'contractorSchema',
    },
};

class ContractorMachineFormContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showSendEmailConfirmationModal: false,
            sendEmailLoading: false,
        };
    }

    showSendEmailConfirmationModal = () => {
        this.setState({showSendEmailConfirmationModal: true});
    };

    hideSendEmailConfirmationModal = () => {
        this.setState({showSendEmailConfirmationModal: false});
    };

    moreOptions() {
        const {
            moreOptionSelected,
        } = this.state;

        return [
            {
                id: 'send_email',
                title: I18nUtils.tr('TR_SOLICITAR_INFORMACION_A_LA_SUBCONTRATA'),
                active: moreOptionSelected === OptionsMore.ASK_INFORMATION_TO_CONTRACTOR,
                onClick: () => this.showSendEmailConfirmationModal(),
            },
        ];
    }

    renderHeaderOptions() {
        return (
            <HeaderSearchRefreshFilterOptions
                moreOptions={this.moreOptions()}
                enableFilter={false}
                enableSearch={false}
                enableRefresh={false}
                cardSearchFilterEnabled={false}
            />
        );
    }

    render() {
        const {
            title,
            onSubmit,
            canWrite,
            handleSubmit,
            machineId,
            contractorId,
            handleSetRefreshQrToken,
            refreshQrToken,
            handleTokenLoading,
            loading,
            canSendInfoEmail,
        } = this.props;
        const {
            showSendEmailConfirmationModal,
            sendEmailLoading,
        } = this.state;

        return (
            <Card loading={loading || sendEmailLoading}>
                <CardHeader
                    title={title.toUpperCase()}
                    rightOptions={machineId && canSendInfoEmail && this.renderHeaderOptions()}
                />
                <CardBody>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.LICENSE_PLATE}
                                label={I18nUtils.tr('TR_MATRICULA_CODIGO_O_NUMERO_DE_SERIE')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_LA_IDENTIFICACION_DE_LA_MAQUINARIA')}
                                component={FormText}
                                disabled={!canWrite}
                            />
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.STATE}
                                label={I18nUtils.tr('TR_ESTADO')}
                                labelDisabled={I18nUtils.tr('TR_INACTIVO')}
                                labelEnabled={I18nUtils.tr('TR_ACTIVO')}
                                component={FormSwitch}
                                disabled={!canWrite}
                            />
                        </Row>
                        <Row>
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.BRAND}
                                label={I18nUtils.tr('TR_MARCA')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_LA_MARCA_DE_LA_MAQUINARIA')}
                                component={FormText}
                                disabled={!canWrite}
                            />
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.MODEL}
                                label={I18nUtils.tr('TR_MODELO')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_EL_MODELO_DE_LA_MAQUINARIA')}
                                component={FormText}
                                disabled={!canWrite}
                            />
                        </Row>
                        <Row>
                            <Field
                                col="col-md-12"
                                name={FORM.FIELDS.DESCRIPTION}
                                label={I18nUtils.tr('TR_DESCRIPCION')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_UNA_DESCRIPCION_DE_LA_MAQUINARIA')}
                                component={FormText}
                                disabled={!canWrite}
                            />
                        </Row>
                        <Row>
                            <ResourceOutsource
                                col="col-sm-12"
                                name={FORM.FIELDS.OUTSOURCE}
                                disabled={!canWrite}
                            />
                        </Row>
                        <Row>
                            <ResourceContractorSchema
                                col="col-sm-10"
                                name={FORM.FIELDS.CONTRACTOR_SCHEMA}
                                disabled={!canWrite}
                                documentSchemaType={DocumentSchemaType.MACHINE}
                                machineId={machineId}
                                contractorId={contractorId}
                                handleSetRefreshQrToken={handleSetRefreshQrToken}
                                refreshQrToken={refreshQrToken}
                                handleTokenLoading={handleTokenLoading}
                            />
                        </Row>
                        {
                            canWrite ? (
                                <Row>
                                    <Field
                                        label={I18nUtils.tr('TR_GUARDAR')}
                                        name="submit"
                                        col="col-md-6 col-md-offset-6"
                                        component={FormSubmit}
                                    />
                                </Row>
                            ) : null
                        }
                    </form>
                </CardBody>

                <ConfirmModal
                    show={showSendEmailConfirmationModal}
                    onHide={this.hideSendEmailConfirmationModal}
                    onAccept={this.sendCompanyMachineMissingEmail}
                    title={I18nUtils.tr('TR_SOLICITAR_INFORMACION_A_LA_SUBCONTRATA')}
                    bodyText={
                        <React.Fragment>
                            {I18nUtils.tr('TR_ESTAS_A_PUNTO_DE_ENVIAR_UN_CORREO_PARA_SOLICITAR_INFORMACION')}
                            <br/>
                            {I18nUtils.tr('TR_DESEAS_CONTINUAR')}
                        </React.Fragment>
                    }
                />
            </Card>
        );
    }

    sendCompanyMachineMissingEmail = () => {
        const {
            machineId
        } = this.props;

        const request = new SendCompanyMachineMissingInfoEmailRequest(machineId);

        this.hideSendEmailConfirmationModal();
        this.setState({sendEmailLoading: true});
        new SendCompanyMachineMissingInfoEmailTask(request.id())
            .onSuccess(() => {
                this.setState({sendEmailLoading: false});
                Alert.success(I18nUtils.tr('TR_CORREO_ENVIADO_CORRECTAMENTE'));
            })
            .onFail(error => {
                Alert.error(error);
                this.setState({sendEmailLoading: false});
            })
            .execute();
    }
}

export const MachineForm = reduxForm({
    form: FORM.NAME,
    validate: MachineFormValidator.validate,
})(ContractorMachineFormContent);

MachineForm.propTypes = {
    title: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
    canWrite: PropTypes.bool.isRequired,
    machineId: PropTypes.number,
    contractorId: PropTypes.number,
    handleSetRefreshQrToken: PropTypes.func,
    refreshQrToken: PropTypes.bool,
    handleTokenLoading: PropTypes.func,
    loading: PropTypes.bool,
    canSendInfoEmail: PropTypes.bool,
};

MachineForm.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/form/MachineForm.jsx